import React from "react";

export default function Footer() {
  return (
    <footer className="main-footer">
      <strong>
        Copyright © 2024 <a href="https://www.dorsia.es/">WmClinics</a>.
      </strong>{" "}
      Todos los derechos reservados.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.0
      </div>
    </footer>
  );
}
